<template>
    <div class="person_box animate__animated animate__fadeIn">
        <div class="person">
            <div class="search_box">
                <div class="box_line">
                    <div class="line_input">
                        <div class="input_title">人员姓名</div>
                        <input type="text" class="input_box" placeholder="请输入人员姓名" v-model="searchName" />
                    </div>
                    <div class="line_input">
                        <div class="input_title">所属班组</div>
                        <input type="text" class="input_box" placeholder="请输入所属班组" v-model="searchDepartment" />
                    </div>
                    <div class="line_input">
                        <div class="input_title">所属工种</div>
                        <input type="text" class="input_box" placeholder="请输入所属工种" v-model="searchPosition" />
                    </div>
                    <div class="line_input">
                        <div class="input_title">身份证号</div>
                        <input type="text" class="input_box" placeholder="请输入身份证号" v-model="searchId" />
                    </div>
                    <div class="line_input">
                        <div class="input_title">创建时间</div>
                        <el-date-picker
                            size="small"
                            v-model="searchCreateDate"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 392px;"
                        ></el-date-picker>
                    </div>
                    <div class="search-btn" @click="fnSearch"><span>搜索</span></div>
                </div>
                <div class="box_line">
                    <!-- 添加人员 -->
                    <div class="search-btn" @click="fnCheckPerWindowOpen"><span>添加巡检人</span></div>
                </div>
            </div>
            <div class="cont_list">
                <div class="list_title">
                    <div class="title_item">姓名</div>
                    <div class="title_item">可见光照</div>
                    <div class="title_item">性别</div>
                    <div class="title_item">身份证号</div>
                    <div class="title_item">班组</div>
                    <div class="title_item">工种</div>
                    <div class="title_item">联系电话</div>
                    <div class="title_item">状态</div>
                    <div class="title_item">创建时间</div>
                    <div class="title_item">操作</div>
                </div>
                <div class="list_boxes">
                    <div class="list_box">
                        <div v-if="tableData">
                            <div class="box_line" v-for="(item, index) in tableData" :key="index">
                                <div class="list_item">{{ item.name }}</div>
                                <div class="list_item"><img :src="item.photo || 'http://cqxtkj.oss-cn-chengdu.aliyuncs.com/image/40fd31b9434de0d6cc965f1c2b475368.jpg'" /></div>
                                <div class="list_item">{{ item.sex == '1' ? '男' : '女' }}</div>
                                <div class="list_item">{{ item.idcard }}</div>
                                <div class="list_item" :title="fnTeamFormat(item.department)">{{ fnTeamFormat(item.department) }}</div>
                                <div class="list_item" :title="fnTeamFormat(item.position)">{{ fnTeamFormat(item.position) }}</div>
                                <div class="list_item">{{ item.phone }}</div>
                                <div class="list_item" :class="item.status ? 'green-c' : 'red-c'">{{ item.status ? '启用中' : '已禁用' }}</div>
                                <div class="list_item">{{ item.add_time }}</div>
                                <div class="list_item">
                                    <div>
                                        <button class="search-btn red" @click="fnDelete(item)"><span>删除</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cont_page">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="pageSizes"
                    :page-size="pageSize"
                    :current-page="currentPage"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageTotal"
                />
            </div>
            <!-- 添加编辑班组弹窗 -->
            <div class="dialog_team" v-if="checkPerWindow">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="添加巡检人" center :visible.sync="checkPerWindow">
                    <div class="reason_body">
                        <div class="body_item">巡检人姓名</div>
                        <div class="body_item">
                            <el-select
                                size="small"
                                class="select_box"
                                v-model="checkPersonId"
                                :popper-append-to-body="false"
                                filterable
                                placeholder="请选择"
                                style="border-radius: 0;"
                            >
                                <el-option label="请选择" value></el-option>
                                <el-option v-for="item in checkPerson" :key="item.id" :label="item.value" :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="checkPerWindow = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnAddCheck"><span>保存</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import APP from '@/utils/base';
import request from '@/utils/request';
import Cookies from 'js-cookie';
import { getUserInfo } from '@/utils/auth';

export default {
    data() {
        return {
            // 分页
            pageSize: APP.PAGE.LIMIT,
            pageSizes: APP.PAGE.SIZE_OPTION,
            currentPage: APP.PAGE.SKIP_PAGE,
            pageTotal: 0,

            // 搜索
            userInfo: null, // 登录账户信息
            searchName: '', // 人员姓名搜索
            searchDepartment: '', // 班组搜索
            searchPosition: '', // 工种搜索
            searchId: '', // 身份证号搜索
            searchCreateDate: '', // 创建时间搜索
            serchtime: '', //搜索时间格式化

            // 人员
            tableData: [], // 人员列表数据
            checkPerson: [], // 巡检人列表
            checkPerWindow: false, // 添加、编辑班组弹窗
            checkPersonId: ''
        };
    },
    created() {
        this.userInfo = getUserInfo();
        this.fnInit();
    },
    methods: {
        // 初始化
        fnInit() {
            this.fnGetPersonnel(
                {
                    page: this.currentPage,
                    size: this.pageSize
                },
                res => {
                    let _arr = res.data.query;
                    if (_arr.length > 0) {
                        this.tableData = _arr;
                    } else {
                        this.tableData = [];
                        this.$message.warning('暂无数据');
                    }
                    this.pageTotal = res.data.count;
                }
            );
        },

        // 分页选择
        handleSizeChange(val) {
            this.pageSize = val;
            this.fnSearch();
        },
        // 分页跳转
        handleCurrentChange(val) {
            this.currentPage = val;
            this.fnSearch();
        },
        // 获取人员列表
        fnGetPersonnel(_obj, _cb) {
            request({
                url: 'qualitySafe/safeIns',
                method: 'GET',
                params: _obj
            })
                .then(res => {
                    _cb && _cb(res);
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 搜索
        fnSearch(_isInit) {
            if (this.searchCreateDate) {
                this.serchtime = this.searchCreateDate[0] + ',' + this.searchCreateDate[1];
            } else {
                this.serchtime = '';
            }
            this.fnGetPersonnel(
                {
                    page: _isInit ? 1 : this.currentPage,
                    size: this.pageSize,
                    name: this.searchName,
                    department: this.searchDepartment,
                    position: this.searchPosition,
                    idcard: this.searchId,
                    status: this.searchStatus,
                    add_time: this.serchtime
                },
                res => {
                    let _arr = res.data.query;
                    if (_arr.length > 0) {
                        this.tableData = _arr;
                    } else {
                        this.tableData = [];
                        this.$message.warning('暂无搜索数据');
                    }
                    this.pageTotal = res.data.count;
                }
            );
        },
        // 班组格式化 去除 #
        fnTeamFormat(_name) {
            return APP.fnTeamFormat(_name);
        },

        // 删除人员
        fnDelete(_data) {
            request({
                url: 'qualitySafe/delSafeIns',
                method: 'POST',
                data: {
                    id: _data.id
                }
            })
                .then(res => {
                    this.$message.success(res.data);
                    this.fnSearch();
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 获取巡检人列表
        fnGetList() {
            request({
                url: 'qualitySafe/safePerson',
                method: 'GET'
            })
                .then(res => {
                    let _data = res.data;
                    let _arr = [];
                    for (var i in _data) {
                        let _obj = {
                            id: i,
                            value: _data[i]
                        };
                        _arr.push(_obj);
                    }
                    this.checkPerson = _arr;
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 打开弹窗
        fnCheckPerWindowOpen() {
            this.fnGetList();
            this.$nextTick(() => {
                this.checkPerWindow = true;
            });
        },
        // 保存添加
        fnAddCheck() {
            if (!this.checkPersonId) {
                this.$message.warning('请选择巡检人');
                return;
            }
            request({
                url: 'qualitySafe/safeIns',
                method: 'POST',
                data: {
                    personnel_id: this.checkPersonId
                }
            })
                .then(res => {
                    this.$message.success(res.data);
                    this.checkPerWindow = false;
                    this.fnInit();
                })
                .catch(err => {
                    this.checkPerWindow = false;
                    this.$message.error(err.data);
                });
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixin.scss';
.person_box {
    width: 1920px;
    height: 858px;
    position: relative;
    overflow: hidden;
    .person {
        position: absolute;
        left: 0;
        right: -20px;
        top: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
    }
}
.search_box {
    height: 88px;
    width: 1880px;
    margin-top: 24px;
    margin-left: 20px;
    @include flex-box(space-between, center, column);
    .box_line {
        width: 1880px;
        height: 32px;
        @include flex-box(flex-start, center);
        .line_input {
            min-width: 280px;
            height: 30px;
            margin-right: 10px;
            border-top-right-radius: 1px;
            border-bottom-right-radius: 1px;
            background-color: rgba(49, 88, 128, 0.4);
            @include flex-box(flex-start, center);
            .input_title {
                width: 69px;
                height: 30px;
                font-size: 14px;
                color: #9bf9fc;
                border-radius: 2px;
                background-color: rgba(155, 249, 252, 0.1);
                @include flex-box(center, center);
            }
            .input_box {
                width: 211px;
                height: 30px;
                line-height: 30px;
                padding-left: 15px;
                color: rgba(77, 180, 244, 0.7);
                font-size: 12px;
                border-radius: 2px;
                outline: none;
                background: transparent;
                border: none;
                &::-webkit-input-placeholder {
                    color: rgba(77, 180, 244, 0.7);
                }
                &::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    color: rgba(77, 180, 244, 0.7);
                }
                &:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    color: rgba(77, 180, 244, 0.7);
                }
                &:-ms-input-placeholder {
                    /* Internet Explorer 10-11 */
                    color: rgba(77, 180, 244, 0.7);
                }
            }
        }
    }
}
.cont_list {
    margin-top: 29px;
    margin-left: 28px;
    width: 1864px;
    height: 621px;
    border-radius: 10px;
    background-color: rgba(29, 68, 149, 0.1);
    .list_title {
        width: 1864px;
        height: 48px;
        background: url(../../../assets/img/per_list_bg.png) no-repeat;
        background-size: 100% 100%;
        @include flex-box(flex-start, center);
        .title_item {
            height: 48px;
            @include flex-box(center, center);
            &:nth-child(1) {
                width: 146px;
                margin: 0 4px 0 40px;
            }
            &:nth-child(2) {
                width: 146px;
                margin-right: 4px;
            }
            &:nth-child(3) {
                width: 146px;
                margin-right: 4px;
            }
            &:nth-child(4) {
                width: 216px;
                margin-right: 4px;
            }
            &:nth-child(5) {
                width: 196px;
                margin-right: 4px;
            }
            &:nth-child(6) {
                width: 196px;
                margin-right: 4px;
            }
            &:nth-child(7) {
                width: 146px;
                margin-right: 4px;
            }
            &:nth-child(8) {
                width: 146px;
                margin-right: 4px;
            }
            &:nth-child(9) {
                width: 210px;
                margin-right: 4px;
            }
            &:nth-child(10) {
                width: 200px;
            }
        }
    }
    .list_boxes {
        width: 1864px;
        height: 573px;
        position: relative;
        overflow: hidden;
        .list_box {
            position: absolute;
            left: 0;
            right: -25px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
            .box_line {
                width: 1784px;
                height: 70px;
                margin: 7px 0 0 40px;
                font-size: 16px;
                color: #ffffff;
                border-bottom: 1px dashed #1d4495;
                @include flex-box(flex-start, center);
                &:hover {
                    background-color: rgba(49, 88, 128, 0.4);
                }
                .list_item {
                    height: 70px;
                    text-align: center;
                    @include flex-box(center, center);
                    &:nth-child(1) {
                        width: 146px;
                        margin-right: 4px;
                    }
                    &:nth-child(2) {
                        width: 146px;
                        margin-right: 4px;
                    }
                    &:nth-child(3) {
                        width: 146px;
                        margin-right: 4px;
                    }
                    &:nth-child(4) {
                        width: 216px;
                        margin-right: 4px;
                    }
                    &:nth-child(5) {
                        width: 196px;
                        margin-right: 4px;
                        cursor: pointer;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    &:nth-child(6) {
                        width: 196px;
                        margin-right: 4px;
                        cursor: pointer;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    &:nth-child(7) {
                        width: 146px;
                        margin-right: 4px;
                    }
                    &:nth-child(8) {
                        width: 146px;
                        margin-right: 4px;
                    }
                    &:nth-child(9) {
                        width: 210px;
                        margin-right: 4px;
                    }
                    &:nth-child(10) {
                        width: 200px;
                    }
                    img {
                        width: 60px;
                        height: 60px;
                        border-radius: 50%;
                    }
                    &.green-c {
                        color: #89d340;
                    }
                    &.red-c {
                        color: #df7475;
                    }
                    div {
                        @include flex-box(center, center);
                    }
                }
            }
        }
    }
}
.box_line {
    >>> .el-input__inner {
        width: 211px;
        height: 30px;
        border-radius: 2px;
        border: none;
        color: rgba(77, 180, 244, 0.7);
        background: transparent;
        &::-webkit-input-placeholder {
            color: rgba(77, 180, 244, 0.7);
        }
        &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: rgba(77, 180, 244, 0.7);
        }
    }
    >>> .el-select__caret {
        color: rgba(77, 180, 244, 0.7);
    }
    >>> .el-select-dropdown {
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(77, 180, 244, 1);
    }
    >>> .popper__arrow {
        border-bottom-color: rgba(77, 180, 244, 1) !important;
    }
    >>> .el-select-dropdown__item {
        color: rgba(77, 180, 244, 0.7);
    }
    >>> .el-select-dropdown__item:hover {
        color: #409eff;
    }
    >>> .el-select-dropdown__item.hover {
        color: #409eff;
    }
    >>> .el-input__icon {
        color: rgba(77, 180, 244, 0.7);
    }
    >>> .el-range-input {
        color: rgba(77, 180, 244, 0.7);
        background: transparent;
        &::-webkit-input-placeholder {
            color: rgba(77, 180, 244, 0.7);
        }
        &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: rgba(77, 180, 244, 0.7);
        }
        &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: rgba(77, 180, 244, 0.7);
        }
    }
    >>> .el-range-separator {
        color: rgba(77, 180, 244, 0.7);
    }
}
.dialog_team {
    >>> .el-dialog {
        width: 500px;
        height: 255px;
        margin-top: 30vh !important;
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(58, 116, 221, 1);
    }
    >>> .el-form-item__label {
        color: #4db4f4;
    }
    >>> .el-dialog__title {
        color: #4db4f4;
    }
    >>> .el-dialog__close {
        color: #4db4f4;
    }
    .reason_body {
        width: 440px;
        height: 40px;
        line-height: 40px;
        color: #4db4f4;
        margin: 0 auto;
        @include flex-box();
        .body_item {
            height: 40px;
            color: #ffffff;
            &:first-child {
                width: 120px;
                text-align: center;
            }
            &:nth-child(2) {
                width: 320px;
            }
            .input_box {
                background-color: rgba(49, 88, 128, 0.6);
                width: 320px;
                height: 30px;
                line-height: 40px;
                padding-left: 15px;
                color: #4db4f4;
                font-size: 12px;
                border-radius: 2px;
                outline: none;
                border: none;
                &::-webkit-input-placeholder {
                    color: rgba(77, 180, 244, 0.7);
                }
                &::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    color: rgba(77, 180, 244, 0.7);
                }
                &:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    color: rgba(77, 180, 244, 0.7);
                }
                &:-ms-input-placeholder {
                    /* Internet Explorer 10-11 */
                    color: rgba(77, 180, 244, 0.7);
                }
            }
            .select_box {
                width: 320px;
                height: 30px;
                line-height: 30px;
                border-radius: 2px;
                background-color: rgba(49, 88, 128, 0.6);
            }
        }
        >>> .el-input__inner {
            width: 211px;
            height: 30px;
            border-radius: 2px;
            border: none;
            color: rgba(77, 180, 244, 0.7);
            background: transparent;
            &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
            }
            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
            }
            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
            }
            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
            }
        }
        >>> .el-select__caret {
            color: rgba(77, 180, 244, 0.7);
        }
        >>> .el-select-dropdown {
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(77, 180, 244, 1);
        }
        >>> .popper__arrow {
            border-bottom-color: rgba(77, 180, 244, 1) !important;
        }
        >>> .el-select-dropdown__item {
            color: rgba(77, 180, 244, 0.7);
        }
        >>> .el-select-dropdown__item:hover {
            color: #409eff;
        }
        >>> .el-select-dropdown__item.hover {
            color: #409eff;
        }
        >>> .el-input__icon {
            color: rgba(77, 180, 244, 0.7);
        }
    }
    .btn_line {
        @include flex-box(center, center);
    }
}
</style>



// WEBPACK FOOTER //
// src/views/SafetyCheckPerson/safetyCheckPersonDefault/index.vue